import { makeAutoObservable } from 'mobx';

interface Modal {
    open: boolean;
    body: JSX.Element | null;
    closeOnEscape?: boolean;
    closeOnDimmerClick?: boolean;
    isCard?: boolean;

}

export default class ModalStore {
    modal: Modal = {
        open: false,
        body: null
    }

    constructor() {
        makeAutoObservable(this);
    }

    openModal = (content: JSX.Element) => {
        this.modal.open = true;
        this.modal.body = content;
        this.modal.closeOnDimmerClick = false;
        this.modal.closeOnEscape = false;
    }

    closeModal = () => {
        this.modal.open = false;
        this.modal.body = null;
    }
    setIsCard = (isCard) => {
        this.modal.isCard = isCard;
    }
}